import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextField, Button, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { listarCampanhas } from '../../services/campanhaService';

const FormPeriodo = ({ onSubmit, periodoInicial = {} }) => {
  const [periodo, setPeriodo] = useState({
    nome: '',
    campanhaId: '',
    ...periodoInicial
  });
  const [campanhas, setCampanhas] = useState([]);

  useEffect(() => {
    const fetchCampanhas = async () => {
      try {
        const data = await listarCampanhas();
        setCampanhas(data);
      } catch (error) {
        console.error('Erro ao buscar campanhas:', error);
      }
    };

    fetchCampanhas();
  }, []);

  useEffect(() => {
    if (periodoInicial && Object.keys(periodoInicial).length > 0) {
      setPeriodo(prevPeriodo => ({
        ...prevPeriodo,
        ...periodoInicial
      }));
    }
  }, [periodoInicial]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPeriodo(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(periodo);
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        fullWidth
        label="Nome do Período"
        name="nome"
        value={periodo.nome ?? ''}
        onChange={handleChange}
        margin="normal"
        required
      />
      <FormControl fullWidth margin="normal">
        <InputLabel>Campanha</InputLabel>
        <Select
          name="campanhaId"
          value={periodo.campanhaId ?? ''}
          onChange={handleChange}
          required
        >
          {campanhas.map((campanha) => (
            <MenuItem key={campanha.id} value={campanha.id}>
              {campanha.nome}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
        {periodo.id ? 'Atualizar Período' : 'Criar Período'}
      </Button>
    </form>
  );
};

FormPeriodo.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  periodoInicial: PropTypes.shape({
    nome: PropTypes.string,
    campanhaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.number,
  }),
};

export default FormPeriodo;
